<template>
  <StyledDiv
    class="graphicWrap"
    justifyContent="flex-start"
    alignItems="flex-start"
    width="75%"
    margin="80px 0"
  >
    <StyledText
      :fontFamily="styled('fontFamily-GothamMedium')"
      :color="styled('pdfPink')"
      :fontSize="styled('fontSize-mediumLarge')"
      :mobileFontSize="styled('fontSize-medium')"
      >Did You Know...</StyledText
    >
    <StyledDiv
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="space-around"
      margin="30px 0"
      class="childrenWrap"
    >
      <SingleChild v-for="(c, i) in children" :key="i" :info="c" :number="i" />
    </StyledDiv>
    <StyledDiv margin="15px 0">
      <StyledText
        :color="styled('pdfPink')"
        :fontSize="styled('fontSize-medium')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :fontFamily="styled('fontFamily-GothamMedium')"
        >4th grade students in the US read proficiently?</StyledText
      >
    </StyledDiv>
    <StyledDiv>
      <StyledText
        :smallTabletFontSize="styled('fontSize-tiny')"
        textAlign="left"
        :fontSize="styled('fontSize-mediumSmall')"
        >Can you imagine learning to code - using Google and online resources -
        when you struggle to read proficiently?</StyledText
      >
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import { children } from "../helpers/children";
import SingleChild from "./SingleChild";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText,
    SingleChild
  },
  data() {
    return {
      children: children
    };
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
@media (max-width: 1000px) {
  .graphicWrap {
    width: 100%;
    padding: 0 15px;
  }
}
@media (max-width: 800px) {
  .childrenWrap {
    justify-content: center;
  }
}
@media (max-width: 420px) {
  /* .childrenWrap {
    justify-content: flex-end;
  } */
}
</style>
